import { Heading, VStack } from "@chakra-ui/react";

export default function NotFound() {
  return (
    <VStack w="100%" p={4}>
      <Heading textAlign={"center"}>Page Not Found</Heading>
    </VStack>
  );
}
